<template>
    <SurveyLayout nextPageId="TestPage" :progressStep="2" headerImg="@/assets/imgs/logo.svg">
        <template #header-text>Test 2</template>
    </SurveyLayout>
</template>